import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a462ff6a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ht-wrap"
};
const _hoisted_2 = {
  class: "ht-header"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ht-title"
}, "🔥 市场热度", -1));
const _hoisted_4 = {
  key: 0,
  class: "ht-id"
};
const _hoisted_5 = {
  class: "ht-hero"
};
const _hoisted_6 = {
  key: 0,
  class: "ht-goalLine"
};
const _hoisted_7 = {
  class: "ht-teams"
};
const _hoisted_8 = {
  key: 0,
  class: "ht-block"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ht-block-title"
}, "🎯 组合研判", -1));
const _hoisted_10 = {
  key: 0,
  class: "ht-tags"
};
const _hoisted_11 = {
  key: 1,
  class: "ht-tags"
};
const _hoisted_12 = {
  key: 1,
  class: "ht-block"
};
const _hoisted_13 = {
  key: 0,
  class: "ht-group-title"
};
const _hoisted_14 = {
  key: 1,
  class: "ht-row"
};
const _hoisted_15 = {
  class: "ht-row-name"
};
const _hoisted_16 = {
  key: 0,
  class: "ht-single-tag"
};
const _hoisted_17 = {
  class: "ht-cells"
};
const _hoisted_18 = {
  key: 2,
  class: "ht-row ht-row-single"
};
const _hoisted_19 = {
  class: "ht-row-name"
};
const _hoisted_20 = {
  class: "ht-cells"
};
const _hoisted_21 = {
  class: "ht-val"
};
const _hoisted_22 = {
  class: "ht-block ht-charts"
};
import { ref, computed } from 'vue';
import { showNotify } from '@nutui/nutui';
import axios from 'axios';
import { count } from './calculation.js';
import RateLineView from './RateLineView.vue';
import HRateLineView from './HRateLineView.vue';
export default {
  __name: 'AnalyzeHeatView',
  setup(__props, {
    expose: __expose
  }) {
    const rateLineValue = ref([]);
    const rateRef = ref(null);
    const hrateRef = ref(null);
    const title = ref('');
    const winTables = ref([]);
    const loseTbales = ref([]);
    const isHeatVisible = ref(false);
    const heatList = ref([]);
    const loading = ref(false);
    const goalLine = ref('');
    const matchIdText = ref('');
    const show = matchId => {
      isHeatVisible.value = true;
      matchIdText.value = matchId;
      winTables.value = [];
      loseTbales.value = [];
      heatList.value = [];
      rateLineValue.value = [];
      getFixedBonusV1(matchId);
    };
    const getFixedBonusV1 = async matchId => {
      loading.value = true;
      try {
        const response = await axios.get('https://webapi.sporttery.cn/gateway/uniform/football/getFixedBonusV1.qry?clientCode=3001&matchId=' + matchId);
        let data = response.data;
        if (data.success) {
          let responseApi = null;
          try {
            responseApi = await axios.get('https://tuhaojie.asia/api-foot/supportRateV1/getRate?matchId=' + matchId);
          } catch {
            // 走势图数据加载失败时忽略，不影响核心指标
          }
          let oddsHistory = data.value.oddsHistory;
          let hhad = oddsHistory.hhadList.length == 0 ? null : oddsHistory.hhadList[oddsHistory.hhadList.length - 1];
          let goalLineValue = hhad.goalLine.indexOf('+') != -1 ? parseInt(hhad.goalLine.split('+')[1]) : parseInt(hhad.goalLine);
          if (responseApi != null) {
            rateRef.value.pushMatch(responseApi.data, goalLineValue);
            hrateRef.value.pushMatch(responseApi.data);
          }
          title.value = oddsHistory.homeTeamAbbName + ' VS ' + oddsHistory.awayTeamAbbName;
          let beiJingRate = null;
          try {
            beiJingRate = await axios.get('https://tuhaojie.asia/api-foot/beijing/getBeiJin?matchId=' + oddsHistory.matchId);
          } catch {
            // 北单赔率加载失败时忽略，不影响核心指标
          }
          goalLine.value = oddsHistory.hhadList[0].goalLine;
          if (data.value.sectionsNo999 != '') {
            title.value = oddsHistory.homeTeamAbbName + ' ' + data.value.sectionsNo999 + ' ' + oddsHistory.awayTeamAbbName;
          }
          const responseRate = await axios.get('https://webapi.sporttery.cn/gateway/jc/common/getSupportRateV1.qry?matchIds=' + oddsHistory.matchId + '&poolCode=hhad,had&sportType=1');
          const dataRate = responseRate.data;
          const value = dataRate.value;
          let changeList = [];
          let had = oddsHistory.hadList.length == 0 ? null : oddsHistory.hadList[oddsHistory.hadList.length - 1];
          const isEmpty = oddsHistory.hadList.length == 0;
          let hadRate = isEmpty ? {} : value['_' + oddsHistory.matchId].HAD;
          let hhadRate = value['_' + oddsHistory.matchId].HHAD;
          let winY = 0;
          let drawY = 0;
          let loseY = 0;
          let hadBettingSingle = 0;
          let hhadBettingSingle = 0;
          oddsHistory.singleList.forEach(item1 => {
            if (item1.poolCode == 'HAD') {
              hadBettingSingle = item1.single;
            } else if (item1.poolCode == 'HHAD') {
              hhadBettingSingle = item1.single;
            }
          });
          if (!isEmpty) {
            let num1 = parseInt(hadRate.hSupportRate.replace('%', '')) - parseInt(hadRate.hProbability.replace('%', ''));
            let num2 = parseInt(hadRate.dSupportRate.replace('%', '')) - parseInt(hadRate.dProbability.replace('%', ''));
            let num3 = parseInt(hadRate.aSupportRate.replace('%', '')) - parseInt(hadRate.aProbability.replace('%', ''));
            changeList.push({
              name: '支持量比例',
              value1: hadRate.hSupportRate,
              value2: hadRate.dSupportRate,
              value3: hadRate.aSupportRate,
              col: 1,
              type: 2,
              num1: num1,
              num2: num2,
              num3: num3
            });
            changeList.push({
              name: '竞猜赔率',
              value1: had.h,
              value2: had.d,
              value3: had.a,
              col: 1,
              type: hadBettingSingle == 0 ? 0 : 3
            });
            changeList.push({
              name: '竞猜赔率胜率',
              value1: hadRate.hProbability,
              value2: hadRate.dProbability,
              value3: hadRate.aProbability,
              col: 1,
              type: 0
            });
            changeList.push({
              name: '支持量',
              value1: hadRate.win,
              value2: hadRate.draw,
              value3: hadRate.lose,
              col: 1,
              type: 0
            });
            const hadTotal = hadRate.win + hadRate.draw + hadRate.lose;
            let winM = count(hadRate.win, had.h, '*');
            let drawM = count(hadRate.draw, had.d, '*');
            let loseM = count(hadRate.lose, had.a, '*');
            winY = count(hadTotal, winM, '-');
            drawY = count(hadTotal, drawM, '-');
            loseY = count(hadTotal, loseM, '-');
            changeList.push({
              name: '总支持量',
              value1: hadTotal,
              value2: hadTotal,
              value3: hadTotal,
              col: 3,
              type: 0
            });
            changeList.push({
              name: '支持量赔付',
              value1: winM,
              value2: drawM,
              value3: loseM,
              col: 1,
              type: 0
            });
            changeList.push({
              name: '竞猜赔付风险',
              value1: winY,
              value2: drawY,
              value3: loseY,
              col: 1,
              type: 1
            });
          }
          let hnum1 = parseInt(hhadRate.hSupportRate.replace('%', '')) - parseInt(hhadRate.hProbability.replace('%', ''));
          let hnum2 = parseInt(hhadRate.dSupportRate.replace('%', '')) - parseInt(hhadRate.dProbability.replace('%', ''));
          let hnum3 = parseInt(hhadRate.aSupportRate.replace('%', '')) - parseInt(hhadRate.aProbability.replace('%', ''));
          changeList.push({
            name: hhad.goalLine + '支持量比',
            value1: hhadRate.hSupportRate,
            value2: hhadRate.dSupportRate,
            value3: hhadRate.aSupportRate,
            col: 1,
            type: 2,
            num1: hnum1,
            num2: hnum2,
            num3: hnum3
          });
          changeList.push({
            name: '竞猜赔率',
            value1: hhad.h,
            value2: hhad.d,
            value3: hhad.a,
            col: 1,
            type: hhadBettingSingle == 0 ? 0 : 3
          });
          changeList.push({
            name: '竞猜赔率胜率',
            value1: hhadRate.hProbability,
            value2: hhadRate.dProbability,
            value3: hhadRate.aProbability,
            col: 1,
            type: 2
          });
          changeList.push({
            name: '支持量',
            value1: hhadRate.win,
            value2: hhadRate.draw,
            value3: hhadRate.lose,
            col: 1,
            type: 0
          });
          const hhadTotal = hhadRate.win + hhadRate.draw + hhadRate.lose;
          let hwinM = count(hhadRate.win, hhad.h, '*');
          let hdrawM = count(hhadRate.draw, hhad.d, '*');
          let hloseM = count(hhadRate.lose, hhad.a, '*');
          let hwinY = count(hhadTotal, hwinM, '-');
          let hdrawY = count(hhadTotal, hdrawM, '-');
          let hloseY = count(hhadTotal, hloseM, '-');
          changeList.push({
            name: '总支持量',
            value1: hhadTotal,
            value2: hhadTotal,
            value3: hhadTotal,
            col: 3,
            type: 0
          });
          changeList.push({
            name: '支持量赔付',
            value1: hwinM,
            value2: hdrawM,
            value3: hloseM,
            col: 1,
            type: 0
          });
          changeList.push({
            name: '竞猜赔付风险',
            value1: hwinY,
            value2: hdrawY,
            value3: hloseY,
            col: 1,
            type: 1
          });
          if (beiJingRate != null && beiJingRate.data.handicap != null) {
            changeList.push({
              name: '北单赔率(' + beiJingRate.data.handicap + ')',
              value1: beiJingRate.data.sp1,
              value2: beiJingRate.data.sp2,
              value3: beiJingRate.data.sp3,
              col: 1,
              type: 0
            });
            changeList.push({
              name: '北单概率(' + beiJingRate.data.handicap + ')',
              value1: beiJingRate.data.sp1Rate + '%',
              value2: beiJingRate.data.sp2Rate + '%',
              value3: beiJingRate.data.sp3Rate + '%',
              col: 1,
              type: 0
            });
          }
          heatList.value = changeList;
          let winTable = [];
          let loseTbale = [];
          if (!isEmpty) {
            let goalLineValue = hhad.goalLine.indexOf('+') != -1 ? parseInt(hhad.goalLine.split('+')[1]) : parseInt(hhad.goalLine);
            if (goalLineValue > 0) {
              if (winY + hwinY > 0) {
                winTable.push('胜+让胜:' + count(winY, hwinY, '+'));
              } else if (winY + hwinY < 0) {
                loseTbale.push('胜+让胜:' + count(winY, hwinY, '+'));
              }
              if (drawY + hwinY > 0) {
                winTable.push('平+让胜:' + count(drawY, hwinY, '+'));
              } else if (drawY + hwinY < 0) {
                loseTbale.push('平+让胜:' + count(drawY, hwinY, '+'));
              }
              if (loseY + hdrawY > 0) {
                winTable.push('负+让平:' + count(loseY, hdrawY, '+'));
              } else if (loseY + hdrawY < 0) {
                loseTbale.push('负+让平:' + count(loseY, hdrawY, '+'));
              }
              if (loseY + hloseY > 0) {
                winTable.push('负+让负:' + count(loseY, hloseY, '+'));
              } else if (loseY + hloseY < 0) {
                loseTbale.push('负+让负:' + count(loseY, hloseY, '+'));
              }
              if (goalLineValue >= 2) {
                if (loseY + hwinY > 0) {
                  winTable.push('负+让胜:' + count(loseY, hwinY, '+'));
                } else if (loseY + hwinY < 0) {
                  loseTbale.push('负+让胜:' + count(loseY, hwinY, '+'));
                }
              }
            } else {
              if (winY + hwinY > 0) {
                winTable.push('胜+让胜:' + count(winY, hwinY, '+'));
              } else if (winY + hwinY < 0) {
                loseTbale.push('胜+让胜:' + count(winY, hwinY, '+'));
              }
              if (winY + hdrawY > 0) {
                winTable.push('胜+让平:' + count(winY, hdrawY, '+'));
              } else if (winY + hdrawY < 0) {
                loseTbale.push('胜+让平:' + count(winY, hdrawY, '+'));
              }
              if (drawY + hloseY > 0) {
                winTable.push('平+让负:' + count(drawY, hloseY, '+'));
              } else if (drawY + hloseY < 0) {
                loseTbale.push('平+让负:' + count(drawY, hloseY, '+'));
              }
              if (loseY + hloseY > 0) {
                winTable.push('负+让负:' + count(loseY, hloseY, '+'));
              } else if (loseY + hloseY < 0) {
                loseTbale.push('负+让负:' + count(loseY, hloseY, '+'));
              }
              if (goalLineValue <= -2) {
                if (winY + hloseY > 0) {
                  winTable.push('胜+让负:' + count(winY, hloseY, '+'));
                } else if (winY + hloseY < 0) {
                  loseTbale.push('胜+让负:' + count(winY, hloseY, '+'));
                }
              }
            }
          } else {
            if (hwinY > 0) {
              winTable.push('让胜:' + hwinY);
            } else if (hwinY < 0) {
              loseTbale.push('让胜:' + hwinY);
            }
            if (hdrawY > 0) {
              winTable.push('让平:' + hdrawY);
            } else if (hdrawY < 0) {
              loseTbale.push('让平:' + hdrawY);
            }
            if (hloseY > 0) {
              winTable.push('让负:' + hloseY);
            } else if (hloseY < 0) {
              loseTbale.push('让负:' + hloseY);
            }
          }
          winTables.value = winTable;
          loseTbales.value = loseTbale;
        } else {
          showNotify.warn(data.errorMessage, {
            duration: 2000
          });
        }
        loading.value = false;
      } catch (error) {
        console.error(error);
        loading.value = false;
      }
    };
    const close = () => {
      isHeatVisible.value = false;
    };

    // ==================== 展示辅助 ====================
    // 指标分组：胜平负 / 让球盘 / 北单
    const groupOf = name => {
      if (name === '支持量比例') return 'had';
      if (name.endsWith('支持量比')) return 'hhad';
      if (String(name).startsWith('北单')) return 'bd';
      return null;
    };
    const groupNames = {
      had: '胜平负',
      hhad: '让球盘',
      bd: '北单'
    };
    const groupedList = computed(() => {
      const out = [];
      let cur = null;
      for (const item of heatList.value) {
        const g = groupOf(item.name);
        if (g) cur = g;
        const isStart = !!(g && (out.length === 0 || out[out.length - 1].group !== g));
        out.push({
          ...item,
          group: cur,
          groupStart: isStart,
          groupTitle: g ? groupNames[g] : ''
        });
      }
      return out;
    });

    // 涨跌箭头：type 1 赔付风险（正红上/负绿下）；type 2 支持量比（±10/±20 分级色）
    const arrowOf = (item, idx) => {
      const val = item['value' + idx];
      if (item.type === 1) {
        if (val > 0) return {
          text: '▲',
          color: '#e74c3c'
        };
        if (val < 0) return {
          text: '▼',
          color: '#16a34a'
        };
        return {
          text: '',
          color: ''
        };
      }
      if (item.type === 2) {
        const n = item['num' + idx];
        if (n <= -20) return {
          text: '▼▼',
          color: '#0b1adb'
        };
        if (n <= -10) return {
          text: '▼',
          color: '#80cef5'
        };
        if (n >= 20) return {
          text: '▲▲',
          color: '#f31a02'
        };
        if (n >= 10) return {
          text: '▲',
          color: '#f3867a'
        };
        return {
          text: '',
          color: ''
        };
      }
      return {
        text: '',
        color: ''
      };
    };
    // 赔付风险数值染色（正红负绿）
    const valClass = (item, idx) => {
      if (item.type === 1) {
        const v = item['value' + idx];
        if (v > 0) return 'val-pos';
        if (v < 0) return 'val-neg';
      }
      return '';
    };

    // eslint-disable-next-line no-undef
    __expose({
      show,
      close
    });
    return (_ctx, _cache) => {
      const _component_var_collapse_item = _resolveComponent("var-collapse-item");
      const _component_var_collapse = _resolveComponent("var-collapse");
      const _component_var_loading = _resolveComponent("var-loading");
      const _component_nut_popup = _resolveComponent("nut-popup");
      return _openBlock(), _createBlock(_component_nut_popup, {
        visible: isHeatVisible.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = $event => isHeatVisible.value = $event),
        closeable: "",
        style: {
          padding: '0',
          height: '85%',
          width: '92%',
          overflow: 'hidden'
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, matchIdText.value ? (_openBlock(), _createElementBlock("span", _hoisted_4, "比赛 " + _toDisplayString(matchIdText.value), 1)) : _createCommentVNode("", true)]), _createVNode(_component_var_loading, {
          loading: loading.value,
          description: "加载中"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [goalLine.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, "让球 " + _toDisplayString(goalLine.value), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, _toDisplayString(title.value), 1)]), winTables.value.length || loseTbales.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_hoisted_9, winTables.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(winTables.value, (w, i) => {
            return _openBlock(), _createElementBlock("span", {
              class: "ht-tag win",
              key: 'w' + i
            }, _toDisplayString(w), 1);
          }), 128))])) : _createCommentVNode("", true), loseTbales.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(loseTbales.value, (l, i) => {
            return _openBlock(), _createElementBlock("span", {
              class: "ht-tag loss",
              key: 'l' + i
            }, _toDisplayString(l), 1);
          }), 128))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), groupedList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedList.value, (item, gi) => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: gi
            }, [item.groupStart ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(item.groupTitle), 1)) : _createCommentVNode("", true), item.col == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createTextVNode(_toDisplayString(item.name) + " ", 1), item.type == 3 ? (_openBlock(), _createElementBlock("span", _hoisted_16, "单")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_17, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3], ci => {
              return _createElementVNode("div", {
                class: "ht-cell",
                key: ci
              }, [_createElementVNode("span", {
                class: _normalizeClass(["ht-val", valClass(item, ci)])
              }, _toDisplayString(item['value' + ci]), 3), arrowOf(item, ci).text ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "ht-arrow",
                style: _normalizeStyle({
                  color: arrowOf(item, ci).color
                })
              }, _toDisplayString(arrowOf(item, ci).text), 5)) : _createCommentVNode("", true)]);
            }), 64))])])) : (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_20, [_createElementVNode("span", _hoisted_21, _toDisplayString(item.value1), 1)])]))], 64);
          }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_22, [_createVNode(_component_var_collapse, {
            modelValue: rateLineValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => rateLineValue.value = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_var_collapse_item, {
              title: "📈 胜平负支持量走势",
              name: "1"
            }, {
              default: _withCtx(() => [_createVNode(RateLineView, {
                ref_key: "rateRef",
                ref: rateRef
              }, null, 512)]),
              _: 1
            }), _createVNode(_component_var_collapse_item, {
              title: "📈 让胜平负支持量走势",
              name: "2"
            }, {
              default: _withCtx(() => [_createVNode(HRateLineView, {
                ref_key: "hrateRef",
                ref: hrateRef
              }, null, 512)]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])])]),
          _: 1
        }, 8, ["loading"])])]),
        _: 1
      }, 8, ["visible"]);
    };
  }
};